<template>
  <div class="bookinfo_wrapper">
    <table class="table table-dark table-bordered">
      <tbody>
        <tr>
          <td width="120px">ISBN</td>
          <td>{{ book.isbn }}</td>
          <td width="120px">저작자</td>
          <td>{{ book.owner }}</td>
        </tr>
        <tr>
          <td>교재명</td>
          <td colspan="3">{{ book.title }}</td>
        </tr>
        <tr>
          <td>학습영역</td>
          <td>{{ book.region }}</td>
          <td>학습대상</td>
          <td>{{ book.target }}</td>
        </tr>
        <tr>
          <td>출간일</td>
          <td>{{ book.pubdate }}</td>
          <td>등록된문항수</td>
          <td>{{ book.qcnt }}</td>
        </tr>
        <tr>
          <td>표지이미지</td>
          <td colspan="3">
            {{ book.coverimg }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    book() {
      return this.$store.state.bookform;
    },
  },
};
</script>


<style lang="scss" scoped>
.bookinfo_wrapper {
  margin-top: 50px;
}
</style>